// react
import React from "react";
import { useSelector } from "react-redux";
import { Outlet } from "react-router-dom";

// selectors
import { getUserID } from "../../selectors/app";

const Body = () => {
	const currentUserID = useSelector((state) => getUserID(state));
	const shouldRender = !!currentUserID;

	return <section className="react-application-body">{shouldRender ? <Outlet /> : null}</section>;
};

export default Body;
